var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9Z",
    fill: "url(#paint0_linear_156_7226)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56 11.7V17.82C7.56 17.9194 7.64059 18 7.74 18H10.26C10.3594 18 10.44 17.9194 10.44 17.82V11.7C10.44 11.6006 10.5206 11.52 10.62 11.52H12.42C12.5194 11.52 12.6 11.4394 12.6 11.34V9.18C12.6 9.08059 12.5194 9 12.42 9H10.62C10.5206 9 10.44 8.91953 10.44 8.82012V7.2C10.44 6.48 11.34 6.12 11.7 6.12H12.78C12.8794 6.12 12.96 6.03941 12.96 5.94V3.78C12.96 3.68059 12.8794 3.6 12.78 3.6H10.44C8.712 3.6 7.56 5.4 7.56 6.48V8.82C7.56 8.91941 7.47941 9 7.38 9H5.58C5.48059 9 5.4 9.08059 5.4 9.18V11.34C5.4 11.4394 5.48059 11.52 5.58 11.52H7.38C7.47941 11.52 7.56 11.6006 7.56 11.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_7226",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0165E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceBookIcon);
export default __webpack_public_path__ + "static/media/FaceBookIcon.ef8f0f57cd626e4b64d683fc353813d5.svg";
export { ForwardRef as ReactComponent };